"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationStep = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _interfaces = require("../interfaces");
var _models = require("../models");
var _virtualPageEventDispatcher = require("../utils/virtualPageEventDispatcher");
var _Verification = require("./Verification");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '500px',
  margin: '0 auto',
  marginTop: theme.spacing(4)
}));
const StyledTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(3),
  fontWeight: 'bold',
  textAlign: 'center'
}));
const VerifyWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column'
}));
const WrapperContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  marginTop: theme.spacing(7),
  paddingInline: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    paddingInline: theme.spacing(0)
  }
}));
const StyledSubTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(8)
}));
const VerificationIcon = (0, _mui.styled)(_icons.CheckCircle)(({
  theme
}) => ({
  fontSize: '60px',
  color: theme.palette.grey.A200
}));
const VerificationIconSuccess = (0, _mui.styled)(_icons.CheckCircleFilled)(({
  theme
}) => ({
  fontSize: '60px',
  color: theme.palette.primary.main
}));
const VerificationStep = props => {
  const {
    configContact,
    registrationID,
    initialData,
    awaitingRes,
    userData,
    onSubmitConfirm,
    isParentalConsent,
    showRegistrationPage
  } = props;
  const {
    autoLoginUrl,
    postLoginRedirectUrl
  } = (0, _contexts.useConfiguration)();
  const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
  const [resendDisabled, setResendDisabled] = (0, _react.useState)(false);
  const [isSuccessConfirm, setIsSuccessConfirm] = (0, _react.useState)(false);
  const {
    handleAutoLogin
  } = (0, _hooks.useAutoLogin)();
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors,
    setErrorData
  } = errorData;
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const {
    virtualPageAnalyticsData
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const {
    setPreviousStep
  } = virtualPageAnalyticsData;
  (0, _react.useEffect)(() => {
    (0, _virtualPageEventDispatcher.virtualPageEventDispatch)('ContactVerification', undefined);
    setPreviousStep('ContactVerification');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- virtual page event should be fired exacly once, no need to reevaluate
  }, []);
  const isEmailVerification = configContact?.isEmailVerificationRequired;
  const isPhoneVerification = configContact?.isTelephoneVerificationRequired;
  const contactTelephone = initialData?.contactDetails?.contactTelephone?.value ?? '';
  const contactEmail = initialData?.contactDetails?.contactEmail?.value ?? '';
  const anyErrors = customErrors?.length && customErrors.length > 0;
  (0, _react.useEffect)(() => {
    if (isSuccessConfirm && !anyErrors && !awaitingRes && !isParentalConsent) {
      onSubmitConfirm();
      handleAutoLogin(autoLoginUrl, {
        UserName: userData.userName,
        Password: userData.password,
        ReturnUrl: postLoginRedirectUrl ?? '/shopping/basket'
      });
    } else if (isSuccessConfirm && !anyErrors && !awaitingRes && isParentalConsent) {
      showRegistrationPage(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed updated on other property
  }, [isSuccessConfirm, anyErrors, awaitingRes, userData]);
  const handleSubmitVerification = async code => {
    setIsSubmitting(true);
    if (initialData) {
      try {
        const createConfirmResponse = await (0, _globalApiClientReact.updateCustomerRegistrationInstruction)(api, registrationID, {
          registrationId: registrationID,
          customerId: initialData.customerId,
          registrationState: isParentalConsent ? 'Pending' : 'Submitted',
          registrationType: initialData.registrationType,
          contactDetails: {
            ...initialData.contactDetails,
            isContactEmailVerified: initialData.contactDetails?.isContactEmailVerified ?? false,
            isContactTelephoneVerified: initialData.contactDetails?.isContactTelephoneVerified ?? false,
            contactEmailConfirmationCode: isEmailVerification ? {
              value: code
            } : null,
            contactTelephoneConfirmationCode: isPhoneVerification ? {
              value: code
            } : null
          }
        });
        const result = new _models.FetchResult(createConfirmResponse.status);
        if (result.isSuccess()) {
          onSubmitConfirm();
          setIsSuccessConfirm(true);
        }
        if (anyErrors) {
          setErrorData([]);
        }
      } catch (error) {
        setNotificationData({
          isOpen: true,
          message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.cannotVerify,
            id: _models.TranslationKey.cannotVerify
          }),
          type: _interfaces.MessageType.error
        });
      }
    }
    setIsSubmitting(false);
  };
  const handleResendCode = async event => {
    event.preventDefault();
    setIsSuccessConfirm(false);
    setErrorData([]);
    setResendDisabled(true);
    setTimeout(() => {
      setResendDisabled(false);
    }, 60000);
    if (initialData) {
      try {
        const resendCodeResponse = await (0, _globalApiClientReact.updateCustomerRegistrationInstruction)(api, registrationID, {
          registrationId: registrationID,
          customerId: initialData.customerId,
          registrationState: initialData.registrationState,
          registrationType: initialData.registrationType,
          contactDetails: initialData.contactDetails
        });
        const result = new _models.FetchResult(resendCodeResponse.status);
        if (result.isSuccess()) {
          setNotificationData({
            isOpen: true,
            message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              defaultMessage: _constants.defaultTranslations.successResend,
              id: _models.TranslationKey.successResend
            }),
            type: undefined
          });
        }
      } catch (error) {
        setNotificationData({
          isOpen: true,
          message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.cannotVerify,
            id: _models.TranslationKey.cannotVerify
          }),
          type: _interfaces.MessageType.error
        });
      }
    }
  };
  const content = isEmailVerification ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrapperContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      variant: "h4",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.EmailVerification_Header,
        id: _models.TranslationKey.EmailVerification_Header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubTitle, {
      variant: "subtitle1",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.EmailVerification_Text,
        id: _models.TranslationKey.EmailVerification_Text,
        values: {
          contactEmail
        }
      })
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrapperContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      variant: "h4",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.PhoneVerification_Header,
        id: _models.TranslationKey.PhoneVerification_Header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubTitle, {
      variant: "subtitle1",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.PhoneVerification_Text,
        id: _models.TranslationKey.PhoneVerification_Text,
        values: {
          contactTelephone
        }
      })
    })]
  });
  const isVerified =
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
  initialData?.contactDetails?.isContactEmailVerified || initialData?.contactDetails?.isContactTelephoneVerified;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [isVerified ? /*#__PURE__*/(0, _jsxRuntime.jsx)(VerificationIconSuccess, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(VerificationIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(VerifyWrapper, {
      children: [content, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Verification.Verify, {
        submitErrors: customErrors,
        handleSubmitVerification: handleSubmitVerification,
        handleResendCode: handleResendCode,
        isSubmitting: isSubmitting,
        isResendDisabled: resendDisabled,
        awaitingRes: awaitingRes
      })]
    })]
  });
};
exports.VerificationStep = VerificationStep;
